/* HabitatAffinityBadge — small "🌿 +X%" chip that appears next to each
 * fighter when the auto-selected arena is their natural biome.
 *
 * Contract:
 *   pct       — number (0.0 = no bonus, 5.0 = +5%, 10.0 = +10%, …)
 *   arena     — arena label ("Wetland", "Forest", …) for the tooltip
 *   compact   — when true, renders a tiny inline chip; else full badge
 *
 * A pct of 0 renders nothing at all, so it's safe to drop this into any
 * fighter card without conditional guards on the caller side.
 */
import { Leaf } from 'lucide-react';

export default function HabitatAffinityBadge({
  pct = 0,
  arena = '',
  compact = false,
  testId = 'habitat-affinity-badge',
}) {
  if (!pct || pct <= 0) return null;
  const label = `+${Math.round(pct)}%`;
  const title = arena
    ? `Home biome — this creature gains ${label} in the ${arena}.`
    : `Home biome bonus ${label}`;
  if (compact) {
    return (
      <span
        title={title}
        data-testid={testId}
        className="inline-flex items-center gap-0.5 px-1.5 py-[1px] rounded-full bg-emerald-500/20 border border-emerald-400/40 text-emerald-100 text-[9px] font-mono uppercase tracking-widest"
      >
        <Leaf className="w-2.5 h-2.5" strokeWidth={2.4} />
        {label}
      </span>
    );
  }
  return (
    <span
      title={title}
      data-testid={testId}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500/15 border border-emerald-400/40 text-emerald-100 text-[10px] font-semibold uppercase tracking-widest shadow-[0_0_10px_-4px_rgba(52,211,153,0.6)]"
    >
      <Leaf className="w-3 h-3" strokeWidth={2.2} />
      Habitat affinity {label}
    </span>
  );
}
